
import PickerColor from '../PickerColor'
import PickerGrade from '../PickerGrade'
import PickerStorage from '../PickerStorage'

export default {
  components: {
    PickerColor,
    PickerGrade,
    PickerStorage,
  },

  props: {
    activeBackboxGrade: {
      type: Number,
      default: 0,
    },
    isAccessory: {
      type: Boolean,
      default: false,
    },
    displayVariant: {
      type: Boolean,
      default: false,
    },
    colors: {
      type: Array,
      default: () => [],
    },
    grades: {
      type: Array,
      default: () => [],
    },
    selectedHighlightedPickers: {
      type: Object,
      default: null,
    },
    storages: {
      type: Array,
      default: () => [],
    },
  },

  data() {
    return {
      loadingId: null,
    }
  },

  watch: {
    $route({ params: newParams } = {}, { params: oldParams } = {}) {
      if (newParams?.uuid !== oldParams?.uuid) {
        this.loadingId = null
      }
    },
  },

  methods: {
    clickOnLinkPicker(itemId) {
      if (this.$route.params.uuid !== itemId.toString()) {
        this.loadingId = itemId
      }
    },
  },
}
